import { render, staticRenderFns } from "./CashDeliveryAdviceEdit.vue?vue&type=template&id=229c9834"
import script from "./CashDeliveryAdviceEdit.vue?vue&type=script&lang=js"
export * from "./CashDeliveryAdviceEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports